import classNames from 'classnames';

import { type Breadcrumb } from '@/types';

import PageTitle from '@/containers/Layout/PageTitle';
import Row from '@/shared/components/2.0/layout/Row';

type Props = React.PropsWithChildren<{
  breadCrumb?: Breadcrumb[];
  className?: string;
  isCompact?: boolean;
  subTitle?: string;
  title?: string;
}>;

const KpcFullPage: React.FC<Props> = ({
  breadCrumb = [],
  children = [],
  className = '',
  isCompact = false,
  subTitle = '',
  title = '',
}) => (
  <div className={classNames('flex flex-col rounded-xl', isCompact ? 'm-0' : 'm-4', className)}>
    {title && breadCrumb && (
      <Row className="flex space-x-4">
        <PageTitle
          breadCrumb={breadCrumb}
          className="flex-grow"
          subTitle={subTitle}
          title={title}
        />
      </Row>
    )}
    {children}
  </div>
);

export default KpcFullPage;
